import { t } from "@redotech/redo-i18n";
import CollapseIcon from "@redotech/redo-icons/collapse-01.svg";
import { Step } from "@redotech/redo-return-core-common/return-flow";
import { combineLabelFromModel } from "@redotech/redo-return-core-common/return-flow-step-from-model";
import {
  CombineLabelState,
  isCombineLabelStepValid,
} from "@redotech/redo-return-core-common/return-flow-step-valid";
import { STEP_TYPE_NAMES } from "@redotech/redo-return-core-common/return-flow/step-type-names";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export const COMBINE_LABEL = (
  Details: React.ComponentType<StepTypeDetailsProps<CombineLabelState>>,
): StepType<CombineLabelState, Step.CombineLabel> => ({
  layout() {
    return BlockLayout.FULL;
  },
  empty: {},

  title: STEP_TYPE_NAMES[Step.COMBINE_LABEL],

  customTitle: (state) => state.customTitle,

  description: (state, team) => {
    const methods = [];
    const skuGroupingEnabled =
      team?.settings.returns?.labelCombination?.combineLabelsSkuGroups
        ?.enabled ?? false;
    const sameFulfillmentEnabled =
      team?.settings.returns?.labelCombination
        ?.onlyCombineLabelsFromSameFulfillment ?? false;

    if (skuGroupingEnabled) {
      methods.push(t("SKU grouping"));
    }
    if (sameFulfillmentEnabled) {
      methods.push(t("Same fulfillment"));
    }
    return `${t("Combine method")}\n${methods.join("\n")}`;
  },

  Icon: CollapseIcon,
  iconColor: "success",

  Details(props) {
    return <Details {...props} />;
  },

  downstream: () => [],

  maxDownstream: () => 0,

  fromModel: (model) => combineLabelFromModel(model),

  toModel: (state) => ({
    type: Step.COMBINE_LABEL,
    customTitle: state.customTitle,
  }),

  valid: (state) => isCombineLabelStepValid(state).valid,

  stepDeleted: (state) => state,
});
